export const DISTANCE_TYPE_OPTIONS = [
  { value: "FIVE_K", label: "5K" },
  { value: "TEN_K", label: "10K" },
  { value: "HALF_MARATHON", label: "Half Marathon" },
  { value: "MARATHON", label: "Marathon" },
  { value: "ULTRA_MARATHON", label: "Ultra Marathon" },
  { value: "OFF_SEASON", label: "Off Season" },
];

export const DISTANCE_TYPES = DISTANCE_TYPE_OPTIONS.map((option) => option.value);

export function normalizeDistanceType(value) {
  const clean = String(value || "").trim();
  const normalized = clean.toUpperCase().replace(/[\s-]+/g, "_");
  const aliases = {
    "5K": "FIVE_K",
    "5_K": "FIVE_K",
    "10K": "TEN_K",
    "10_K": "TEN_K",
    HALF: "HALF_MARATHON",
    HALF_MARATHON: "HALF_MARATHON",
    MARATHON: "MARATHON",
    ULTRA: "ULTRA_MARATHON",
    ULTRA_MARATHON: "ULTRA_MARATHON",
    OFF_SEASON: "OFF_SEASON",
  };
  return aliases[normalized] || (DISTANCE_TYPES.includes(normalized) ? normalized : clean);
}

export function distanceTypeLabel(value) {
  const normalized = normalizeDistanceType(value);
  const option = DISTANCE_TYPE_OPTIONS.find((item) => item.value === normalized);
  return option?.label || String(value || "").replaceAll("_", " ");
}
